(function () {
  // Previous/Next on a collection page is a full browser navigation, not a
  // fetch — there's no response to wait on, so the only feedback available
  // before the new page arrives is dimming the grid the instant the click
  // registers (mirrors .btn.is-added's "acknowledge the click immediately"
  // idea elsewhere in the theme).
  var links = document.querySelectorAll(".pagination__link");
  var grid = document.querySelector(".product-grid");
  if (!links.length || !grid) return;

  links.forEach(function (link) {
    link.addEventListener("click", function () {
      // Matches assets/collection-filters.js's own save/restore — keeps
      // Previous/Next from resetting scroll to the top of the page too.
      sessionStorage.setItem("collectionScrollY", window.scrollY);
      grid.classList.add("is-loading");
    });
  });
})();
